import React from 'react';
import ConfigLayout, { ConfigLayoutPropsType } from 'packages/common/components/ConfigLayout';
import Share from './share';
import { ShareResponse } from '../share/service';
export type Props = {
  /** ___服务端数据源(private) */
  ___dataSource: [ShareResponse];
  /** ___公共参数(private) */

  ___commonParams: ConfigLayoutPropsType['___commonParams'];
};

class ShareLayout extends React.Component<Props> {
  render() {
    return <ConfigLayout {...this.props}>
        <Share {...this.props} />
      </ConfigLayout>;
  }

}

export default ShareLayout;